module.exports = __webpack_public_path__ + "static/hajek-f775ede67ca0c1be30d3480d12c79825.jpg";